import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

const commonInMemoryCache = new InMemoryCache();

export const generateApolloClient = (options = {}) => {
    const queryParams = Object.keys((options.queryParams || {}))
        .map((key) => `${key}=${options.queryParams[key]}`)
        .join('&');
    const queryString = queryParams ? `?${queryParams}` : '';
    const baseUrl = options.baseUrl || '/list/graphql';
    return new ApolloClient({
        cache: commonInMemoryCache,
        link: new HttpLink({
            uri: `${baseUrl}${queryString}`,
            credentials: 'include', // So we get session cookies,
            fetchOptions: {
                timeout: 90000
            }
        })
    });
};

export default {
    generateApolloClient
};
